import React from 'react';
import { Link } from 'react-router-dom';

/**
 * ButtonLink component renders a button styled as a link.
 * @param {Object} props - Component props
 * @param {string} props.link - The target link URL
 * @param {string} props.children - The content of the button
 * @param {string} [props.btnStyle='btn-primary'] - The CSS class to apply to the button (default: 'btn-primary')
 * @returns {JSX.Element} - JSX element representing the ButtonLink component
 */
export default function ButtonLink({ link, children, btnStyle = 'btn-primary' }) {
   return (
      <Link to={link} className={`btn mt-3 ${btnStyle} w-100`}>
         {children}
      </Link>
   );
}
